module.exports = "/static/media/visa.f64af719.png";